import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';

export default class Contracts extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'contract',
            data: null,
            loading: true,
            id_to_remove: null,
            page: 1,
            per_page: 10,
            phrase: ''
        };
    }
    componentDidMount() { this.refreshData(); }

    renderForm() {
        return (
            <div>
                <div className="nk-content-body">
                    <div className="nk-block-head nk-block-head-sm">
                        <div className="nk-block-between">
                            <div className="nk-block-head-content">
                                <h3 className="nk-block-title page-title">فهرست قراردادها</h3>
                                <div className="nk-block-des text-soft">
                                    <p>{this.money(this.state.data?.recordsCount ?? 0)} قرارداد ثبت شده است</p>
                                </div>
                            </div>
                            <div className="nk-block-head-content">
                                <div className="toggle-wrap nk-block-tools-toggle">
                                    <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                    <div className="toggle-expand-content" data-content="pageMenu">
                                        <ul className="nk-block-tools g-3">
                                            <li>
                                                <NavLink to="/contract/new/" className="btn btn-primary"><em className="icon ni ni-plus"></em><span>افزودن قرارداد جدید</span></NavLink>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="nk-block">
                        <div className="card card-bordered card-stretch">
                            {(!this.state.data || this.state.data.recordsCount <= 0) ? (
                                <div className="card-inner-group">
                                    <div className="example-alert">
                                        <div className="alert alert-pro alert-warning">
                                            <div className="alert-text"><h6>توجه</h6><p>هیچ قراردادی ثبت نشده است</p></div>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="card-inner-group">
                                    <div className="card-inner position-relative card-tools-toggle">
                                        <div className="card-title-group">
                                            <form className="card-tools" onSubmit={e => this.refreshData(e)}>
                                                <div className="form-inline flex-nowrap gx-3">
                                                    <div className="form-wrap">
                                                        <input type="text" defaultValue={this.state.phrase} onChange={e => this.state.phrase = e.target.value} placeholder="جستجوی شماره قرارداد / مشتری" className="form-control" />
                                                    </div>
                                                    <div className="btn-wrap">
                                                        <button type="submit" className="btn btn-dim btn-outline-light hand"><em className="icon ni ni-search"></em> جستجو</button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>

                                    <div className="card-inner p-0">
                                        <div className="nk-tb-list nk-tb-ulist">
                                            <div className="nk-tb-item nk-tb-head">
                                                <div className="nk-tb-col"><span className="sub-text">ردیف</span></div>
                                                <div className="nk-tb-col"><span className="sub-text">مشتری</span></div>
                                                <div className="nk-tb-col tb-col-md"><span className="sub-text">شماره قرارداد</span></div>
                                                <div className="nk-tb-col tb-col-sm"><span className="sub-text">تاریخ شروع</span></div>
                                                <div className="nk-tb-col tb-col-sm"><span className="sub-text">تاریخ پایان</span></div>
                                                <div className="nk-tb-col tb-col-md"><span className="sub-text">مبلغ (تومان)</span></div>
                                                <div className="nk-tb-col tb-col-md"><span className="sub-text">پرداخت شده</span></div>
                                                <div className="nk-tb-col tb-col-md"><span className="sub-text">بدهی</span></div>
                                                <div className="nk-tb-col tb-col-sm"><span className="sub-text">خدمات</span></div>
                                                <div className="nk-tb-col text-end"><span className="sub-text">عملیات</span></div>
                                            </div>
                                            {this.state.data.records.map((record, index) => (
                                                <div className="nk-tb-item" key={record.id}>
                                                    <div className="nk-tb-col"><span className="sub-text">{this.genRowNumber(index)}</span></div>
                                                    <div className="nk-tb-col"><span className="sub-text">{record.customerName}</span></div>
                                                    <div className="nk-tb-col tb-col-md"><span className="sub-text">{record.contractNumber}</span></div>
                                                    <div className="nk-tb-col tb-col-sm"><span className="sub-text">{record.startDatePersian}</span></div>
                                                    <div className="nk-tb-col tb-col-sm"><span className="sub-text">{record.endDatePersian || '---'}</span></div>
                                                    <div className="nk-tb-col tb-col-md"><span className="sub-text">{this.money(record.amount)}</span></div>
                                                    <div className="nk-tb-col tb-col-md"><span className="sub-text">{this.money(record.paidAmount)}</span></div>
                                                    <div className="nk-tb-col tb-col-md"><span className={`sub-text ${record.debtAmount > 0 ? 'text-danger' : 'text-success'}`}>{this.money(record.debtAmount)}</span></div>
                                                    <div className="nk-tb-col tb-col-sm"><span className="sub-text">{record.servicesCount}</span></div>
                                                    <div className="nk-tb-col nk-tb-col-tools">
                                                        <ul className="nk-tb-actions gx-1">
                                                            <li className="nk-tb-action-hidden"><NavLink to={`/contract/edit/${record.id}/`} className="btn btn-trigger btn-icon"><em className="icon ni ni-eye-fill"></em></NavLink></li>
                                                            <li className="nk-tb-action-hidden"><a className="btn btn-trigger btn-icon hand" onClick={() => this.confirmRemove(record.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove"><em className="icon ni ni-cross-fill-c"></em></a></li>
                                                            <li>
                                                                <div className="drodown">
                                                                    <a href="#" className="dropdown-toggle btn btn-icon btn-trigger" data-bs-toggle="dropdown"><em className="icon ni ni-more-h"></em></a>
                                                                    <div className="dropdown-menu dropdown-menu-end">
                                                                        <ul className="link-list-opt no-bdr">
                                                                            <li><NavLink to={`/contract/edit/${record.id}/`}><em className="icon ni ni-eye"></em><span>ویرایش</span></NavLink></li>
                                                                            <li><a className="hand" onClick={() => this.confirmRemove(record.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove"><em className="icon ni ni-na"></em><span>حذف</span></a></li>
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    {this.createPaging()}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />;
        let contents = this.state.loading ? this.renderLoading() : [
            this.state.lockScreen === 1 && this.lockScreen(),
            this.getGlobalContainer(),
            <Header data={this.state.data} />,
            <div className="nk-content "><div className="container-fluid"><div className="nk-content-inner">{this.renderForm()}</div></div></div>,
            <Footer />
        ];
        return contents;
    }
}